export { default } from './RegisterPaymentDetails.container';
export { default as RegisterPaymentDetailsDuringActivate } from './RegisterPaymentDetailsDuringActivate.container';
